export class MissingRuntimeNodeToken {}
